/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ar_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The width and height are divided by their greatest common divisor, so 1920×1080 becomes 16:9 and 1280×720 also becomes 16:9.`)
};

const es_ar_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El ancho y la altura se dividen por su máximo común divisor, por lo que 1920×1080 se convierte en 16:9 y 1280×720 también se convierte en 16:9.`)
};

const de_ar_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Breite und Höhe werden durch ihren größten gemeinsamen Teiler geteilt, sodass 1920×1080 zu 16:9 wird und 1280×720 ebenfalls zu 16:9 wird.`)
};

const nl_ar_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De breedte en hoogte worden gedeeld door hun grootste gemene deler, dus 1920×1080 wordt 16:9 en 1280×720 wordt ook 16:9.`)
};

const fr_ar_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La largeur et la hauteur sont divisées par leur plus grand commun diviseur, donc 1920×1080 devient 16:9 et 1280×720 devient aussi 16:9.`)
};

const it_ar_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La larghezza e l'altezza sono divise per il loro massimo divisore comune, quindi 1920×1080 diventa 16:9 e 1280×720 diventa anche 16:9.`)
};

const pt_br2_ar_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A largura e altura são divididas por seu máximo divisor comum, portanto 1920×1080 se torna 16:9 e 1280×720 também se torna 16:9.`)
};

const pt_ar_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A largura e a altura são divididas pelo seu maior divisor comum, portanto 1920×1080 torna-se 16:9 e 1280×720 também torna-se 16:9.`)
};

const ja_ar_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`幅と高さは最大公約数で除算されるため、1920×1080は16:9になり、1280×720も16:9になります。`)
};

const zh_ar_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`宽度和高度会除以它们的最大公约数,因此1920×1080会变为16:9,1280×720同样也会变为16:9。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ar_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ar_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ar_faq1_a", locale)
	if (locale === "en") return en_ar_faq1_a(inputs)
	if (locale === "es") return es_ar_faq1_a(inputs)
	if (locale === "de") return de_ar_faq1_a(inputs)
	if (locale === "nl") return nl_ar_faq1_a(inputs)
	if (locale === "fr") return fr_ar_faq1_a(inputs)
	if (locale === "it") return it_ar_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_ar_faq1_a(inputs)
	if (locale === "pt") return pt_ar_faq1_a(inputs)
	if (locale === "ja") return ja_ar_faq1_a(inputs)
	return zh_ar_faq1_a(inputs)
};